// src/app/modules/ThreatAlerts/database/column-formatters/AlertColumnFormatter.jsx
import React from "react";

export function AlertColumnFormatter(cellContent, row) {
  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 14 }}>{row.description}</div>
      {row.visitor_name && <div className="sety-tbl-sub">Visitor: {row.visitor_name}</div>}
      {row.visitor_phone && <div className="sety-tbl-sub">{row.visitor_phone}</div>}
    </div>
  );
}
